window.Popper = require('@popperjs/core');
// eslint-disable-next-line no-multi-assign
window.$ = window.jQuery = require('jquery');
window.coreui = require('@coreui/coreui');
require('select2');
require('select2/dist/js/i18n/es');
window.flatpickr = require('flatpickr');
require('simplebar');
